// MarketPage.js
import React from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import Carousel from "./Carousel";
import ProductCard from "./ProductCard";
import TopMarketPlace from "./TopMarketPlace";
import ProductTabs from "./ProductTabs";
import { useNavigate } from "react-router-dom";
import { LuPackageCheck } from "react-icons/lu";

const product = {
  image:
    "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=800&q=80",
  title: "Adidas 4D X Parley Running Shoes",
  oldPrice: 444.0,
  price: 333.2,
  discount: 12,
};

const MarketPage = () => {
  const navigate = useNavigate();
  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />
      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8 overflow-x-hidden">
        <LeftResponsivesidebar />
        <Headmenu />

        {/* Quick access to the buyer's orders */}
        <div className="flex justify-end mt-4 mb-2">
          <button
            type="button"
            onClick={() => navigate("/myorder")}
            className="flex items-center gap-2 px-5 py-2 bg-[#095228] text-white rounded-full text-sm font-medium hover:bg-green-800 transition"
          >
            <LuPackageCheck className="text-lg" />
            My Orders
          </button>
        </div>

        {/* Carousel and Product cards section */}
        <div className="">
          <Carousel />
          <ProductCard />
          <TopMarketPlace />
          <ProductTabs />
        </div>
      </main>
    </div>
  );
};

export default MarketPage;
